import ApiService from "./api.service";
import SessionService from "./session.service";
import RouterService from "./router.service";
import HttpService from "./http.service";
import FormsService from "./forms.service";
import ModalsService from "./modals.service";
import ConditionsService from "./conditions.service";
import ReplyService from "./reply.service";

import LocalStorage from "@/storages/local.storage";
import SessionStorage from "@/storages/session.storage";
import CoreService from "@/services/core.service";
import SubmissionsService from "@/services/submissions.service";

export class ServiceProvider {
    /**
     * Constructor
     */
    constructor() {
        this.instances = {};
        this.config = {
            api: {
                baseURL: process.env.VUE_APP_DATA_CAPTURE_API
                    .replace(
                        'ROOT_DOMAIN',
                        (process.env.VUE_APP_ROOT_DOMAIN || window.location.hostname)
                            .split('.')
                            .slice(-2)
                            .join('.')
                    ),
            },
            session: {
                storage: LocalStorage,
            },
            router: {
                storage: SessionStorage,
            },
            modals: {
                store: undefined
            }
        };
    }

    /**
     * Create instance of service
     * @param name string
     * @param type <T>
     * @returns {<T>}
     */
    instantiate(name, type) {
        if (typeof this.instances[name] === 'undefined') {
            this.instances[name] = new type(this, this.config[name] || {});
        }
        return this.instances[name];
    }

    /**
     * Getter
     * @returns {HttpService}
     */
    get http() {
        return this.instantiate(
            'http',
            HttpService
        );
    }

    /**
     * Getter
     * @returns {ApiService}
     */
    get api() {
        return this.instantiate(
            'api',
            ApiService
        );
    }

    /**
     * Getter
     * @returns {SessionService}
     */
    get session() {
        return this.instantiate(
            'session',
            SessionService
        );
    }

    /**
     * Getter
     * @returns {RouterService}
     */
    get router() {
        return this.instantiate(
            'router',
            RouterService
        );
    }

    /**
     * Getter
     * @returns {FormsService}
     */
    get forms() {
        return this.instantiate(
            'forms',
            FormsService
        );
    }

    /**
     * Getter
     * @returns {ModalsService}
     */
    get modals() {
        return this.instantiate(
            'modals',
            ModalsService
        );
    }

    /**
     * Getter
     * @returns {ConditionsService}
     */
    get conditions() {
        return this.instantiate(
            'conditions',
            ConditionsService
        );
    }

    /**
     * Getter
     * @returns {ReplyService}
     */
    get reply() {
        return this.instantiate(
            'reply',
            ReplyService
        );
    }

    /**
     * Getter
     * @returns {CoreService}
     */
    get core() {
        return this.instantiate(
            'core',
            CoreService
        );
    }

    /**
     * Getter
     * @returns {SubmissionsService}
     */
    get submissions() {
        return this.instantiate(
            'submissions',
            SubmissionsService
        );
    }
}

const provider = new ServiceProvider();

export default provider;